import React from "react";
import { graphql, useStaticQuery } from "gatsby";
import InTheNewsComponent from "./component";

const InTheNews = () => {
  const { inthenews: { nodes = [] } = {} } = useStaticQuery(query);
  return <InTheNewsComponent data={nodes} />;
};

const query = graphql`
  query InTheNewsQuery {
    inthenews: allMarkdownRemark(
      filter: { fileAbsolutePath: { glob: "**/press-showcase/**" } }
      sort: { frontmatter: { newsStartDate: DESC } }
    ) {
      nodes {
        id
        frontmatter {
          uid
          title
          linkUrl
          newsStartDate(formatString: "MM/DD/YYYY")
          image {
            extension
            publicURL
            childImageSharp {
              gatsbyImageData
            }
          }
        }
      }
    }
  }
`;

export default InTheNews;
